import { ControlsStrategyType } from './default-controls-strategy';
import {
  ControlsStrategyTypes,
  DefaultControlsStrategy
} from './default-controls-strategy';

export class HideControlsStrategy extends DefaultControlsStrategy {
  type: ControlsStrategyType = ControlsStrategyTypes.HIDE;

  canExpand(): boolean {
    return false;
  }

  shouldDisplayProgressBar(): boolean {
    return false;
  }

  shouldDisplayVastIcon(): boolean {
    return false;
  }

  shouldHideOptout(): boolean {
    return false;
  }

  shouldDisplayOptOut(): boolean {
    return false;
  }
}
